import { Box } from "@mui/material";
import PaginatedDataGrid from "components/PaginatedDataGrid";
import { GridColDef } from "@mui/x-data-grid";
import { formatDistanceToNow } from "date-fns";
import itinerariesService from "services/itineraries";
import { useNavigate } from "react-router-dom";

const Itineraries = () => {
  const navigate = useNavigate();

  const columns: GridColDef[] = [
    {
      field: "title",
      headerName: "Title",
      flex: 1,
    },
    {
      field: "startDate",
      headerName: "Start Date",
      flex: 1,
      valueGetter: (params) => new Date(params.row.startDate).toLocaleDateString(),
    },
    {
      field: "endDate",
      headerName: "End Date",
      flex: 1,
      valueGetter: (params) => new Date(params.row.endDate).toLocaleDateString(),
    },
    {
      field: "organizer.name",
      headerName: "Organizer",
      flex: 1,
      valueGetter: (params) => params.row.organizer?.name,
    },
    {
      field: "updatedAt",
      headerName: "Updated",
      flex: 1,
      valueGetter: (params) =>
        params.row.updatedAt
          ? formatDistanceToNow(new Date(params.row.updatedAt), {
            addSuffix: true,
          })
          : "",
    },
  ];

  const handleRowClick = (params: any) => {
    navigate(`/itineraries/${params.row.id || params.row._id}`);
  };

  return (
    <Box sx={{ height: 400, width: "100%" }}>
      <h1 className="text-xl font-bold mb-4">Itineraries</h1>
      <PaginatedDataGrid
        collectionName="itineraries"
        columns={columns}
        onRowClick={handleRowClick}
        service={itinerariesService}
        defaultSortField="createdAt"
        defaultSortDirection="desc"
        getRowId={(row) => row._id || row.id}
        defaultQuery={[]}
      />
    </Box>
  );
};

export default Itineraries;
